import { Container } from 'inversify';

import { IOC_TYPES } from '../../../../context/ioc.types';
import { SpinnerService } from '../../../../services/spinner.service';
import { UIContext } from '../../../../services/ui-context';
import { Dimension2D } from '../../../../types/geo.types';
import { GeoUtils } from '../../../../utils/geo.utils';
import { HTMLUtils } from '../../../../utils/html.utils';
import { CImage } from './cimage';
import { Photo } from './photo';

export class ImageContainer {
    element = null;
    listeners = new Array();
    photoModal: Photo;
    // showWithSpinner: (fn) => Promise<void>
    spinner: SpinnerService;
    uiContext: UIContext;

    constructor(
        photoModal: Photo,
        containerElement: HTMLDivElement,
        _showWithSpinner: (fn) => Promise<void>,
        injector: Container,
    ) {
        this.photoModal = photoModal;
        this.element = containerElement;
        // this.spinner = injector.get(SpinnerService);
        this.uiContext = injector.get(IOC_TYPES.UIContext);
        this.spinner = injector.get(IOC_TYPES.SpinnerService);
    }

    async showWithSpinner(fn: () => void) {
        const instance = await this.spinner.show();
        setTimeout(async () => {
            try {
                await fn();
            } catch (e) {
                console.error(e);
            }
            this.spinner.hide(instance);
        }, 0);
    }

    public getElement(): HTMLElement {
        return this.element;
    }

    /**
     * Fits the container to its parent element
     */
    public fitContainerToParent() {
        const container = this.getElement();
        const parentElement = this.getElement().parentElement;

        const parentRect = HTMLUtils.getElementBoundingRectangle(parentElement);
        HTMLUtils.css(container, 'width', parentRect.width + 'px');
        HTMLUtils.css(container, 'height', parentRect.height + 'px');
    }

    public bestFitContainerAndCanvas() {
        this.fitContainerToParent();
        this.fitContainerToCanvas();
    }

    public fitContainerToCanvas() {
        const rect1 = document.getElementsByClassName('canvasAndImageHolderParent')[0].getBoundingClientRect();
        const rect2 = document.getElementsByClassName('canvasAndImageHolder')[0].getBoundingClientRect();

        const boundingRect = GeoUtils.getRectIntersection(rect1, rect2);

        const canvasRect = HTMLUtils.getCanvasNatualDimension(this.photoModal.getEphemeralCanvas());

        // if(rect.height > rect.width * )
        // return;
        this.updateParentDimension();
        const parent = this.getElement().parentElement;
        const parentRect = parent.getBoundingClientRect();
        let width = parentRect.width;

        const maxHeight = window.innerHeight - 260;
        const maxWidth = parentRect.width;

        // Height is tricky
        const height = Math.min(boundingRect.height, canvasRect.height * parentRect.width / canvasRect.width);
        const widthRelativeToImageHeight = canvasRect.width * height / canvasRect.height;
        if (parentRect.width > widthRelativeToImageHeight) {
            width = widthRelativeToImageHeight;
        }
        const containerDim = {
            width: width,
            height: height,
        };

        ///// TEST START
        if (canvasRect.width <= parentRect.width && canvasRect.height <= parentRect.height) {
            containerDim.width = canvasRect.width;
            containerDim.height = canvasRect.height;
        } else if (canvasRect.width <= parentRect.width) {
            // containerDim.width = canvasRect.width;
        } else if (canvasRect.height <= parentRect.height) {

        }

        //// TEST END

        this.getElement().style.width = (containerDim.width) + 'px';
        this.getElement().style.height = (containerDim.height) + 'px';

        // WAS REMOVED this.getCurrentEditorMode().notify("resize");
    }

    public async updateImage(image) {
        // this.getElement().empty();
        if (this.getElement().querySelectorAll('img').length) {
            // this.containerImageUpdater.next(image);
            CImage.loadImageSrc(this.getElement().querySelector('img'), image.src);
        } else {
            this.getElement().append(image);
            console.error('Attributes are not inherited');
        }
    }

    public empty() {
        // this.getElement().children().unbind();
        this.getElement().remove();
    }

    /**
     *
     * @param targetRelativeSize if this is canvas size, height is calculate base of this ratio
     */
    public updateParentDimension(targetRelativeSize?: Dimension2D) {
        const containerParent = this.getElement().parentElement.parentElement;
        const allowed_width = containerParent.getBoundingClientRect().width - 20;
        let allowed_height = containerParent.getBoundingClientRect().height;

        if (targetRelativeSize) {
            allowed_height = allowed_width * targetRelativeSize.height / targetRelativeSize.width;
        }

        this.getElement().parentElement.style.width = (allowed_width) + 'px';
        this.getElement().parentElement.style.height = (allowed_height) + 'px';
        return { width: allowed_width, height: allowed_height };
    }

    public createEvent(type, _function) {
        return {
            type: type,
            run: _function,
        };
    }

    public getResizableElement(): HTMLElement {
        return this.getElement().querySelector('#elementResizable');
    }

    public hideCanvas(canvas: HTMLCanvasElement) {
        HTMLUtils.css(canvas, 'display', 'none');
    }

    public hideImage(image: HTMLImageElement) {
        HTMLUtils.css(image, 'display', 'none');
    }

    public addEventListener(listener) {
        this.listeners.push(listener);
    }

    public removeEventListener(listener) {
        const index = this.listeners.indexOf(listener);
        this.listeners.splice(index, 1);
    }

    public notify(type) {
        for (let i = this.listeners.length - 1; i >= 0; i--) {
            if (this.listeners[i].type == type) {
                try {
                    this.listeners[i].run();
                } catch (e) {
                }

            }
        }
        this.fitContainerToCanvas();
    }

    public notifyAll() {
        for (let i = this.listeners.length - 1; i >= 0; i--) {
            this.listeners[i].run();
        }
    }
}
